import React from "react";
import CSMinerPage from "./MinerPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MinerPageContextProvider } from "./context/MinerPageContextProvider";
import { OrgSiteGroupTreeContextProvider } from "./context/OrgSiteGroupTreeContext";

const CSMinerInventoryPage = () => {
    const queryClient = new QueryClient({
        defaultOptions: {
            mutations: {
                // Default options for all mutations
                retry: 1, // Number of retry attempts
                onSuccess: (data) => {
                    console.log("Mutation succeeded:", data);
                },
                onError: (error) => {
                    console.error("Mutation failed:", error);
                },
            },
        },
    });
    return (
        <MinerPageContextProvider>
            <OrgSiteGroupTreeContextProvider>
                <QueryClientProvider client={queryClient}>
                    <CSMinerPage />
                </QueryClientProvider>
            </OrgSiteGroupTreeContextProvider>
        </MinerPageContextProvider>
    );
};

export default CSMinerInventoryPage;
